import { Component } from '@angular/core';
import { GetDemoFormComponent } from 'src/app/components/layout/get-demo-form/get-demo-form.component';

@Component({
  selector: 'app-about',
  standalone: true,
      imports: [GetDemoFormComponent], 
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {

}
